import { SuppliesInventoryConfigStatusSchema } from "@redotech/redo-fulfillment-common/supplies";
import { suppliesInventoryConfigIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const updateSuppliesInventoryConfig = {
  name: "updateSuppliesInventoryConfig" as const,
  input: z.object({
    id: suppliesInventoryConfigIdFormat.schema,
    status: SuppliesInventoryConfigStatusSchema.optional(),
    inventoryReorderThreshold: z.number().int().min(0).optional(),
    suppliesReorderQuantity: z.number().int().min(1).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
